var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Nav'),_c('v-main',{staticClass:"content"},[_c('router-view')],1),_c('we-have-moved',{attrs:{"show":_vm.showPopup},on:{"update:show":function($event){_vm.showPopup=$event}}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }